import styled from '@mui/system/styled';
import Box from '@mui/material/Box';

export const StyledCategoryChip = styled(Box, {
  shouldForwardProp: (prop) => !['bg', 'color', 'border'].includes(prop),
})(({ bg, color, border }) => ({
  display: 'flex',
  alignItems: 'center',
  color: color ?? 'rgba(0,0,0, 0.87)',
  fontWeight: 400,
  padding: '4px 8px',
  height: 23,
  borderRadius: 4,
  background: bg,
  fontSize: 12,
  svg: {
    fontSize: 16,
  },
}));
